import { render, staticRenderFns } from "./GraphTabGroup.vue?vue&type=template&id=35d451dd&scoped=true"
import script from "./GraphTabGroup.vue?vue&type=script&lang=ts"
export * from "./GraphTabGroup.vue?vue&type=script&lang=ts"
import style0 from "./GraphTabGroup.vue?vue&type=style&index=0&id=35d451dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d451dd",
  null
  
)

export default component.exports